import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import Login from './pages/Login';
import RecoveryPassword from './pages/RecoveryPassword';
import Sales from './pages/Sales';
import Shifts from './pages/Shifts';
import Brokers from './pages/Brokers';
import AboutBrokers from './pages/AboutBrokers';
import Managers from './pages/Managers';
import AboutManagers from './pages/AboutManagers';
import Super from './pages/Super';
import AboutSuper from './pages/AboutSuper';
import Directors from './pages/Directors';
import AboutDirectors from './pages/AboutDirectors';
import Agendamentos from './pages/Agendamentos';
import Sidebar from './components/Sidebar';
import AgendamentosCorretores from './pages/AgendamentosCorretores';
import AgendamentosGerentes from './pages/AgendamentosGerentes';
import AgendamentosSuperintendentes from './pages/AgendamentosSuperintendentes';
import Leads from './pages/Leads';
import SalesDetails from './pages/SalesDetails';

import { isAuthenticated } from './services/auth';
import LeadsCorretores from './pages/LeadsCorretores';
import LeadsGerentes from './pages/LeadsGerentes';
import LeadsSuperintendentes from './pages/LeadsSuperintendentes';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: "/login" }} />
            )
        }
    />
);

const ToLogin = () => (
    <Redirect to={{ pathname: "/login" }} />
);

const Init = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const token = urlParams.get('token');
    const origin = urlParams.get('origin');
    const regionId = urlParams.get('region_id');
    const regionNome = urlParams.get('region_nome');
    const regionSlug = urlParams.get('region_slug');
    const to = urlParams.get('to') || ''; // Garante que `to` seja uma string válida

    const regionString = regionId && regionNome && regionSlug
        ? new URLSearchParams({
            region_id: regionId,
            region_nome: regionNome,
            region_slug: regionSlug,
        }).toString()
        : '';

    const redirectTo = regionString ? `${to}?${regionString}` : to;

    localStorage.setItem('token', token || '');
    localStorage.setItem('origin', origin || '');

    return <Redirect to={redirectTo} />;
};

const Routes = () => (
    <BrowserRouter>
        <Sidebar />
        <Switch>
            <Route exact path="/" component={ToLogin} />
            <Route exact path="/init" component={Init} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/recovery-password" component={RecoveryPassword} />
            <PrivateRoute exact path="/sales" component={Sales} />
            <PrivateRoute exact path="/sales/details" component={SalesDetails} />
            <PrivateRoute exact path="/shifts" component={Shifts} />
            <PrivateRoute exact path="/brokers" component={Brokers} />
            <PrivateRoute exact path="/brokers/:id" component={AboutBrokers} />
            <PrivateRoute exact path="/managers" component={Managers} />
            <PrivateRoute exact path="/managers/:id" component={AboutManagers} />
            <PrivateRoute exact path="/super" component={Super} />
            <PrivateRoute exact path="/super/:id" component={AboutSuper} />
            <PrivateRoute exact path="/directors" component={Directors} />
            <PrivateRoute exact path="/directors/:id" component={AboutDirectors} />
            <PrivateRoute exact path="/agendamentos" component={Agendamentos} />
            <PrivateRoute exact path="/agendamentos/corretores" component={AgendamentosCorretores} />
            <PrivateRoute exact path="/agendamentos/gerentes" component={AgendamentosGerentes} />
            <PrivateRoute exact path="/agendamentos/superintendentes" component={AgendamentosSuperintendentes} />
            <PrivateRoute exact path="/leads" component={Leads} />
            <PrivateRoute exact path="/leads/corretores" component={LeadsCorretores} />
            <PrivateRoute exact path="/leads/gerentes" component={LeadsGerentes} />
            <PrivateRoute exact path="/leads/superintendentes" component={LeadsSuperintendentes} />
        </Switch>
    </BrowserRouter>

)

export default Routes;